<template>
  <div class="top">
    <slot name="default" />
  </div>
</template>

<style lang="scss" scoped>
  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px 20px;
    min-width: 0;
  }
</style>
